import { AfterPaymentError, NativeStoreError } from '@forest/paywall-core'
import { isHTTPError } from 'ky'
import { isConnectivityError } from '~/lib/is-connectivity-error'

/** Maps a subscribe error to the focus-pass-equivalent Intercom node. The
 *  vocabulary (iap_unexpected_error, open_order, after_payment_error,
 *  payment_timeout) is what support tooling indexes against. */
export function classifySubscribeIntercomNode(error: unknown): string {
  if (error instanceof AfterPaymentError) return 'after_payment_error'
  if (error instanceof NativeStoreError) return 'iap_unexpected_error'
  if (isConnectivityError(error)) {
    return 'payment_timeout'
  }
  if (isHTTPError(error)) return 'open_order'
  return 'iap_unexpected_error'
}
